import * as React from "react";
import { AutomationForm, AutomationFormScope } from "../Form/AutomationForm";
import { Button } from "@mui/material";
import { IAutomation } from "../../../../config/automation";
import { createAutomation } from "../../../../stores/automations";
import { Add } from "@mui/icons-material";

interface ICreateActionProps {
    onSave(value: any): void;
}

const NewButton = ({onClick}: any) => (
    <Button
        size="small"
        startIcon={<Add />}
        onClick={onClick}
        className="add-new-automation-cta"
    >
        Add new automation
    </Button>
);

export const CreateAction = ({onSave}: ICreateActionProps) => {
    const handleCreate = (value: any): Promise<IAutomation> => {
        return createAutomation(value).then(res => {
            onSave(res);
            return res;
        });
    };

    return (
        <AutomationForm
            scope={AutomationFormScope.CREATE}
            title="New automation"
            onSave={handleCreate}
            trigger={<NewButton />}
        />
    )
};
